import classNames from 'classnames';

import Icon, { Icons } from '../icons/Icon';

type LoadingFullscreenProps = {
  className?: string;
};

function LoadingFullscreen({ className }: LoadingFullscreenProps) {
  return (
    <div
      data-testid="loading-fullscreen"
      className={classNames('absolute left-[calc(50%-64px)] top-[calc(50%-64px)]', className)}
    >
      <Icon name={Icons.Rotate} spin className="text-9xl" />
    </div>
  );
}

export default LoadingFullscreen;
